import React from "react";
import DraggablePanel from "./DraggablePanel";
import { formatShortcutCombo, getShortcutDisplayGroups } from "../../shortcuts/defaultBindings";

const SHORTCUT_GROUPS = getShortcutDisplayGroups();

const ShortcutsPanel = ({ open, onClose, titleIcon }) => {
  return (
    <DraggablePanel
      open={open}
      onClose={onClose}
      title="Shortcuts"
      titleIcon={titleIcon}
      initialSize={{ width: 420, height: 520 }}
      minWidth={320}
      minHeight={360}
    >
      <div className="flex-1 overflow-auto p-3">
        <div className="space-y-4">
          {SHORTCUT_GROUPS.map((group) => (
            <section key={group.title} className="space-y-1">
              <h3 className="px-2 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
                {group.title}
              </h3>
              <div className="overflow-hidden rounded-md border border-gray-700/80">
                {group.shortcuts.map((shortcut, index) => (
                  <div
                    key={shortcut.actionId}
                    className={[
                      "flex min-h-9 items-center justify-between gap-4 px-3 py-2 text-sm",
                      index > 0 ? "border-t border-gray-700/70" : "",
                    ]
                      .filter(Boolean)
                      .join(" ")}
                  >
                    <span className="min-w-0 truncate text-gray-100">{shortcut.label}</span>
                    <span className="shrink-0 whitespace-nowrap text-xs text-gray-300">
                      {shortcut.combos.map(formatShortcutCombo).join(" / ")}
                    </span>
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </DraggablePanel>
  );
};

export default React.memo(ShortcutsPanel);
